import { useState, createRef, useEffect } from 'react';
import Banner from './components/Banner';
import Header from './components/Header';
import Nav from './components/Nav';
import Skills from './components/Skills';
import Resume from './components/Resume';
import Work from './components/Work';
import Contact from './components/Contact';

const App = () => {
  const [activeComp, setActiveComp] = useState();
  const [pageHeight, setPageHeight] = useState();

  const compNameList = ["home", "skills", "work", "resume", "contact"];
  const refs = compNameList.reduce((refsObj, name) => {
    refsObj[name] = createRef(); 
    return refsObj;
  }, {});

  useEffect(() => {
    setPageHeight(window.innerHeight);
    window.addEventListener('resize', (e) => {
      setTimeout(() => {
        setPageHeight(window.innerHeight);
      }, 300);
    });
  }, []);

  const handleClick = (name) => {
    window.scrollTo({
    top: refs[name].current.offsetTop,
    behavior: 'smooth',
    });
  };

  return (
    <div className='bg-main bg-no-repeat bg-cover overflow-hidden'>
      <Header />
      <Banner 
      activeComp={activeComp} 
      setActiveComp={setActiveComp} 
      pageHeight={pageHeight} 
      refs={refs}
      handleClick={handleClick}
      />
      <Nav activeComp={activeComp} handleClick={handleClick} />
      <Work activeComp={activeComp} setActiveComp={setActiveComp} pageHeight={pageHeight} refs={refs}/>
      <Skills 
      activeComp={activeComp} 
      setActiveComp={setActiveComp} 
      pageHeight={pageHeight} 
      refs={refs}
      handleClick={handleClick}
      />
      <Resume activeComp={activeComp} setActiveComp={setActiveComp} pageHeight={pageHeight} refs={refs}/>
      <Contact activeComp={activeComp} setActiveComp={setActiveComp} pageHeight={pageHeight} refs={refs}/>
    </div>
  );
};

export default App;
